import React from 'utils/react';
import { Modal } from 'baseui/modal';
import debug from 'utils/debug';
import { useEffect, useState } from 'react';

const D2 = debug('c:ModalWindows:FullScreen');

const FullScreen = (props) => {
  D2.S.INFO('FullScreen', props);

  const [isOpen, setIsOpen] = useState(false);
  const [contentComponent, setContentComponent] = useState(<React.Fragment />);
  useEffect(() => {
    window.openFullScreen = (opts) => {
      const options = opts || {};
      setContentComponent(options?.modalContent);
      setIsOpen(true);
    };
    window.closeFullScreen = () => {
      setIsOpen(false);
    };
  }, []);

  return (
    <React.Fragment>
      <Modal
        overrides={{
          Root: { style: { zIndex: 21 } },
          Dialog: {
            style: {
              marginTop: '0px',
              marginRight: '0px',
              marginLeft: '0px',
              marginBottom: '0px',
              minHeight: '100vh',
              maxHeight: '100vh',
              display: 'flex',
              flexDirection: 'column',
            },
          },
        }}
        size='100%'
        isOpen={isOpen}
        closeable={false}
      >
        {contentComponent}
      </Modal>
    </React.Fragment>
  );
};
window.openFullScreen = () => {};
window.closeFullScreen = () => {};

export default FullScreen;
